// @ts-nocheck
/**
 * 動的市場システム - カテゴリと所属属性
 *
 * CSVの実際のカテゴリ名に基づく定義
 */

// ========================================
// カテゴリ → 属性 マッピング
// ========================================

export const CATEGORY_ATTRIBUTES = {
  // 炎属性
  'ドラゴン': '炎',
  'フェニックス': '炎',
  'サラマンダー': '炎',
  'ワイバーン': '炎',
  'マグマフォージ': '炎',

  // 水属性
  'リヴァイアサン': '水',
  'マーメイド': '水',
  'タイドウェーブ': '水',

  // 光属性
  '鳥': '光',
  'エンジェル': '光',
  '天使': '光',
  'ルミナフォース': '光',
  'スカイレジェンド': '光',
  'プリンセス': '光',

  // 闇属性
  'シャドウ': '闇',
  'ゴースト': '闇',
  'スケルトン': '闇',
  'デーモン': '闇',
  'ディープシャドウ': '闇',
  'ダークドウェラ': '闇',
  'アビスソウル': '闇',
  'ソウルカース': '闇',
  '魔族': '闇',
  'ブラック・オラクル': '闇',

  // 原始属性
  'スライム': '原始',
  'ビースト': '原始',
  'プラント': '原始',
  'インセクト': '原始',
  'スネーク': '原始',
  'コア・ビースト': '原始',
  '幻獣': '原始',
  '蛮族': '原始',

  // 未来属性
  'ゴーレム': '未来',
  'マシン': '未来',
  'エクラシア': '未来',

  // 複数属性・特殊
  'ウィザード': null,
  '魔導士': null,
  'ヒューマノイド': null,
  'ソルジャー': null,
  'ガーディアン': null,
  'スピリット': null,
  'トラベラー': null,
  'カイザー': null,
  'ライバル': null,
  '鎖': null,
  '虚蝕': null,
  'パペットマスター': null,
  'ポイズンウェイル': null,
};

// ========================================
// カテゴリ一覧
// ========================================

export const CATEGORIES = Object.keys(CATEGORY_ATTRIBUTES);

// ========================================
// 属性 → カテゴリ マッピング（逆引き）
// ========================================

export const ATTRIBUTE_CATEGORIES = {
  '炎': ['ドラゴン', 'フェニックス', 'サラマンダー', 'ワイバーン', 'マグマフォージ'],
  '水': ['リヴァイアサン', 'マーメイド', 'タイドウェーブ'],
  '光': ['鳥', 'エンジェル', '天使', 'ルミナフォース', 'スカイレジェンド', 'プリンセス'],
  '闇': ['シャドウ', 'ゴースト', 'スケルトン', 'デーモン', 'ディープシャドウ', 'ダークドウェラ', 'アビスソウル', 'ソウルカース', '魔族', 'ブラック・オラクル'],
  '原始': ['スライム', 'ビースト', 'プラント', 'インセクト', 'スネーク', 'コア・ビースト', '幻獣', '蛮族'],
  '未来': ['ゴーレム', 'マシン', 'エクラシア'],
  'なし': [],
};

// ========================================
// ヘルパー関数
// ========================================

/**
 * カテゴリから属性を取得
 * @param {string} category - カテゴリ名
 * @returns {string|null} 属性名（複数属性の場合はnull）
 */
export const getAttributeForCategory = (category) => {
  return CATEGORY_ATTRIBUTES[category] || null;
};

/**
 * 属性からカテゴリ一覧を取得
 * @param {string} attribute - 属性名
 * @returns {string[]} カテゴリ名の配列
 */
export const getCategoriesForAttribute = (attribute) => {
  return ATTRIBUTE_CATEGORIES[attribute] || [];
};

// ========================================
// エクスポート
// ========================================

export default {
  CATEGORY_ATTRIBUTES,
  CATEGORIES,
  ATTRIBUTE_CATEGORIES,
  getAttributeForCategory,
  getCategoriesForAttribute,
};
